export enum InputTypeEnum {
    RADIO = 'radio',
    SELECT = 'select',
    MULTISELECT = 'multiselect'
}

export const INPUT_TYPE_ENUM = Object.values(InputTypeEnum).map((inputType) => ({
    value: inputType,
    label: inputType
}));